import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/CloseAlt.svg'

export const IconCloseAlt = IconSVG as IconComponent
